export default "__VITE_ASSET__BDPr5aik__"